import { Severity } from './bulma.js';
import { Notification } from './notification.js';
import { i18n } from '../i18n.js';

export type MessageLike = {
    severity: Severity;
    message: string;
}

/**
 * a message to be displayed to the user
 * this is basically a notification shown inside a modal.
 */
export class Message {
    /**
     * displays a message to the user
     *
     * @deprecated use Notification.createModal()
     */
    public static log(severity: Severity, rawMsg: string, msgSubstitution?: string, error?: Error): void {
        const msg = i18n.has_translation(rawMsg) ? i18n.t(rawMsg, msgSubstitution) : rawMsg;
        Notification.createModal(msg, severity);
    };
}
